module.exports = __webpack_public_path__ + "img/ufton_b3.7d5411c4.jpg";